import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import LogosMarquee from "@/pages/home/components/LogosMarquee";
import Services from "@/pages/home/components/Services";
import Differentials from "@/pages/home/components/Differentials";
import Stats from "@/pages/home/components/Stats";
import Coverage from "@/pages/home/components/Coverage";
import Cases from "@/pages/home/components/Cases";
import TechStack from "@/pages/home/components/TechStack";
import Contact from "@/pages/home/components/Contact";
import CtaBand from "@/pages/home/components/CtaBand";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-bg">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <LogosMarquee />
        <Differentials />
        <Stats />
        <Coverage />
        <Cases />
        <TechStack />
        <Contact />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}
